<template>
    <div class="board">
        <div class="bar">
            <b-icon icon="camera" class="icon"></b-icon>
            <span>ภาพถ่ายร้านค้า</span>
            <button class="edit" @click="toggleEditStore()">
                <b-icon icon="pencil-fill"></b-icon>
            </button>
        </div>

        <div class="content">
            <div class="form" v-if="formData">
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-4 mb-4" v-for="index in totalPicture" :key="index">
                        <div class="input-picture">
                            <template v-if="formData.picture['picture' + index] !== ''">
                                <button @click="setPicture('', (index))" v-if="isEditStore">
                                    <b-icon icon="x"></b-icon>
                                </button>
                                <img :src="formData.picture['picture' + index]" />
                            </template>
                        </div>
                        <take-picture
                            fileErrorTitle="ประเภทไฟล์ไม่ถูกต้อง!"
                            fileErrorMessage="โปรดเลือกไฟล์รูปภาพที่เป็น JPG หรือ PNG เท่านั้น"
                            @load="setPicture($event, (index))"
                            v-if="isEditStore"
                        >ถ่ายรูป</take-picture>
                    </div>
                </div>

                <div class="mt-3 text-right" v-if="isEditStore">
                    <button class="btn btn-main" @click="savePicture()">บันทึก</button>
                    <button class="btn btn-grey-outline" @click="cancel()">ยกเลิก</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Helper from '@/resources/Helper';

export default {
    data() {
        return {
            totalPicture: 3,
            isEditStore: false,
            displayData: null,
            formData: null
        }
    },
    props: {
        fieldData: Object
    },
    watch: {
        fieldData(value) {
            this.setData(value);
        }
    },
    methods: {
        setPicture(value, index) {
            this.formData.picture['picture' + index] = value;
        },
        toggleEditStore() {
            this.isEditStore = true;
        },
        setData(data) {
            this.displayData = data;
            this.formData = Helper.cloneObject(this.displayData);
        },
        savePicture() {
            this.isEditStore = false;
            this.displayData = Helper.cloneObject(this.formData);

            this.$emit('saveData', {
                group: 'picture',
                data: this.displayData
            });
        },
        cancel() {
            this.isEditStore = false;
            this.formData = Helper.cloneObject(this.displayData);
        }
    }
}
</script>